<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>题库管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="searchForm">
          <el-form-item>
            <el-select  v-model="searchForm.type" placeholder="请选择题目类型">
                <el-option v-for='(item,index) in typeSelect' :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="创建开始日期"
                end-placeholder="创建结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                >
              </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showAddDialog()">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="questionbanks" highlight-current-row v-loading="loading" border style="width: 100%;">
        <el-table-column type="index" label="序号" width="60" fixed="left" align="center"></el-table-column>
        <el-table-column prop="type" label="题目类型" width="120" align="center" :formatter="formatType"></el-table-column>
        <el-table-column prop="correct" label="正确选项" width="120"  align="center" ></el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="180"  align="center"></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="180"  align="center"></el-table-column>
        <el-table-column label="操作" fixed="right"  align="center"  width="250" >
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="showDetailDialog(scope.$index,scope.row)">详情</el-button>
            <el-button type="primary" size="mini" @click="showEditDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="delQuestion(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>

      <!-- 添加界面 -->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" ref="addForm">
           <el-form-item label="标题">
            <el-input type="textarea" v-model="addForm.data.title" placeholder="标题"></el-input>
          </el-form-item>
          <el-form-item label="题目类型"  class="clear-margin-bottom">
            <el-radio-group v-model="addForm.data.type">
              <el-radio label="1" border>单选题</el-radio>
              <el-radio label="2" border>判断题</el-radio>
              <el-radio label="3" border>多选题</el-radio>
            </el-radio-group>
          </el-form-item>
         
          <el-form-item label="正确选项" class="clear-margin-bottom">
            <el-input v-model="addForm.data.correct" auto-complete="off" placeholder="正确选项"></el-input>
          </el-form-item>
          <el-form-item label="答题选项" class="clear-margin-bottom">
            <el-row>
              <el-button type="success" icon="el-icon-plus" size="mini" circle @click="addForm.add"></el-button>
            </el-row>
            <el-table
              :data="addForm.data.answers"
              style="width: 100%">
              <el-table-column
                prop="optionCode"
                label="编码"
                width="80">
              </el-table-column>
              <el-table-column
                prop="optionContent"
                label="内容">
              </el-table-column>
              <el-table-column label="操作" fixed="right"  align="center"  width="150" >
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="addForm.edit(scope.$index,scope.row)">编辑</el-button>
                  <el-button type="danger" size="mini" @click="addForm.delete(scope.$index,scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" >提交</el-button>
        </div>
      </el-dialog>
      <!-- 添加界面 答题选项 -->
      <el-dialog title="答题选项" :visible.sync="answerFormVisible" :close-on-click-modal="false">
        <el-form :model="answerForm" label-width="80px" ref="answerForm">
          <el-form-item label="选项编码" class="clear-margin-bottom">
             <el-select  v-model="answerForm.optionCode" placeholder="选项编码">
                <el-option v-for='(item,index) in answerCode' :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选项内容">
            <el-input type="textarea" v-model="answerForm.optionContent" placeholder="选项内容"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="answerFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="answerForm.submit" >提交</el-button>
        </div>
      </el-dialog>

      <!--详情、编辑窗-->
      <el-dialog :title="detailEditDialogTitle" :visible.sync="detailEditDialogVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" ref="addForm">
           <el-form-item label="标题">
            <el-input type="textarea" v-model="addForm.data.title" placeholder="标题"></el-input>
          </el-form-item>
          <el-form-item label="题目类型"  class="clear-margin-bottom">
            <el-radio-group v-model="addForm.data.type">
              <el-radio :label="1" border>单选题</el-radio>
              <el-radio :label="2" border>判断题</el-radio>
              <el-radio :label="3" border>多选题</el-radio>
            </el-radio-group>
          </el-form-item>
         
          <el-form-item label="正确选项" class="clear-margin-bottom">
            <el-input v-model="addForm.data.correct" auto-complete="off" placeholder="正确选项"></el-input>
          </el-form-item>
          <el-form-item label="答题选项" class="clear-margin-bottom">
            <el-row>
              <el-button type="success" icon="el-icon-plus" size="mini" circle @click="addForm.add" :style="detialEditDialogButton"></el-button>
            </el-row>
            <el-table
              :data="addForm.data.answers"
              style="width: 100%">
              <el-table-column
                prop="optionCode"
                label="编码"
                width="180">
              </el-table-column>
              <el-table-column
                prop="optionContent"
                label="内容"
                width="">
              </el-table-column>
              <el-table-column label="操作" fixed="right"  align="center"  width="250" >
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="addForm.edit(scope.$index,scope.row)" :style="detialEditDialogButton">编辑</el-button>
                  <el-button type="danger" size="mini" @click="addForm.delete(scope.$index,scope.row)" :style="detialEditDialogButton">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          
        </el-form>
        <div slot="footer" class="dialog-footer" :style="detialEditDialogButton">
          <el-button @click.native="detailEditDialogVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" >提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import util from '../../common/util'
import API from '../../api/exam/api_question';
export default {
    data(){
      return{
        questionbanks:[],
        loading:false,
        total: 0,
        page: 1,
        limit: 10,
        //题目类型值
        typeSelect:[
          {label:'全部',value:''},
          {
            label:"单选题",
            value:1
          },
           {
            label:"判断题",
            value:2
          },
           {
            label:"多选题",
            value:3
          }
        ],
        //查询条件
        searchForm:{
          type:"",
          date:""
        },
        addForm:{
          data:{
            type:'',
            title:'',
            correct:'',
            answers:[],
          },
          add:function(){},
          edit:function(){},
          delete:function(){}
        },
        addFormVisible: false,
        answerCode:['A','B','C','D','E','F','G','H','I','J','K','L','M','N'],
        answerForm:{
          optionCode:"",
          optionContent:"",
          submit:function(){}
        },
        answerFormVisible:false,
        detailEditDialogVisible: false,
        detialEditDialogButton:"display:none",
        detailEditDialogTitle:'',
        //编辑题目的行索引
        editIndex:null
      }
    },
    methods: {
      //题目类型格式化
      formatType: function (row, column) {
        var text = '';
        switch (row.type){
          case 1 : text="单选题";break;
          case 2 : text="判断题";break;
          case 3 : text="多选题";break;
        }
        return text;
      },
      //添加
      showAddDialog: function () {
        let that = this;
        that.addFormVisible=true;
        that.addForm={
          data:{
            type:'',
            title:'',
            correct:'',
            answers:[],
          },
          //添加选项
          add:function(){
            that.answerFormVisible=true;
            that.answerForm.optionCode='';
            that.answerForm.optionContent='';
            //获取已经添加的选项
            that.answerCode=['A','B','C','D','E','F','G','H','I','J','K','L','M','N'];
            console.log(that.addForm.data.answers);
            if(that.addForm.data.answers.length>0)
            {
              that.addForm.data.answers.forEach((item) => {
                  let index = that.answerCode.indexOf(item.optionCode);
                  that.answerCode.splice(index,1)
                  console.log(that.answerCode);
              });
            }
            //添加选项提交
            that.answerForm.submit=function(){
              that.addForm.data.answers.push({optionCode:that.answerForm.optionCode,optionContent:that.answerForm.optionContent});
              that.answerFormVisible = false
            }
          },
          //编辑选项
          edit:function(index,row){
            that.answerFormVisible=true;
            //赋值
            that.answerForm.optionCode=row.optionCode;
            that.answerForm.optionContent=row.optionContent;
            //获取已经添加的选项
            that.answerCode=['A','B','C','D','E','F','G','H','I','J','K','L','M','N'];
            if(that.addForm.data.answers.length>0)
            {
              that.addForm.data.answers.forEach((item) => {
                if(item.optionCode!=row.optionCode){
                  let index = that.answerCode.indexOf(item.optionCode);
                  that.answerCode.splice(index,1);
                }
              });
            };
            //编辑提交
            that.answerForm.submit=function(){
              let answerTemp = that.addForm.data.answers[index];
              answerTemp.optionCode =that.answerForm.optionCode;
              answerTemp.optionContent = that.answerForm.optionContent;
              that.answerFormVisible = false
            }
          },
          //删除选项
          delete:function(index,row){
            that.addForm.data.answers.splice(index,1);
          }
        };
      },
      //分页切换每页条数
      handleSizeChange:function(val){
        this.limit = val;
        this.search();
      },
      //分页切换页码
      handleCurrentChange:function(val){
        this.page = val;
        this.search();
      },
      //查询按钮
      handleSearch:function(){
        this.page=1;
        this.total=0;
        this.search();
      },
      //查询方法
      search:function(){
        let that = this;
        let startDate='';
        let endDate='';
        if(that.searchForm.date && that.searchForm.date.length>0){
          startDate = that.searchForm.date[0];
          endDate=that.searchForm.date[1];
        }
        console.log(this.searchForm.date);
        let params = {
          page: this.page,
          limit: this.limit,
          type:this.searchForm.type,
          startDate:startDate,
          endDate:endDate
        };
        //加载
        API.getList(params)
          .then(
            function (result) {
              that.loading = false;
              if (result && result.code == 200) {
                if(result.data  && result.data.records)
                {
                    that.total= result.data.total;
                    that.questionbanks=result.data.records;
                }
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      },
      //添加题目提交
      addSubmit: function () {
        let that = this;
        let params=that.addForm.data;
        that.loading =true;
        API.add(params)
         .then(
            function (result) {
              that.loading = false;
              if (result && result.code == 200) {
                if(result.data)
                {
                  that.addFormVisible=false;
                  //成功，重新加载数据
                  that.total= that.total+1;
                  let temp =[];
                  temp.push(result.data);
                  that.questionbanks=temp.concat(that.questionbanks);
                }
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      },
      //详情按钮
      showDetailDialog:function(index,row){
        let that = this;
        that.detialEditDialogButton="display:none";
        that.detailEditDialogVisible=true;
        that.detailEditDialogTitle='题目详情';
        let params ={
          questionId:row.id
        };
        that.loading = true;
        API.getDetail(params)
          .then(
            function (result) {
              that.loading = false;
              if (result && result.code == 200) {
                that.addForm.data=result.data;
                that.addForm.add=function(){};
                that.addForm.edit=function(){};
                that.addForm.delete=function(){};
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
        
      },
      //编辑按钮
      showEditDialog:function(index,row){
        let that = this;
        that.editIndex = index;
        that.detialEditDialogButton="display:inline-block";
        that.detailEditDialogVisible=true;
        that.detailEditDialogTitle='编辑题目';
        
        let params ={
          questionId:row.id
        };
        that.loading = true;
        API.getDetail(params)
          .then(
            function (result) {
              that.loading = false;
              if (result && result.code == 200) {
                that.addForm.data=result.data;
                //添加选项
                that.addForm.add=function(){
                  that.answerFormVisible=true;
                  that.answerForm.optionCode='';
                  that.answerForm.optionContent='';
                  //获取已经添加的选项
                  that.answerCode=['A','B','C','D','E','F','G','H','I','J','K','L','M','N'];
                  console.log(that.addForm.data.answers);
                  if(that.addForm.data.answers.length>0)
                  {
                    that.addForm.data.answers.forEach((item) => {
                        let index = that.answerCode.indexOf(item.optionCode);
                        that.answerCode.splice(index,1)
                        console.log(that.answerCode);
                    });
                  }
                  //添加选项提交
                  that.answerForm.submit=function(){
                    that.addForm.data.answers.push({optionCode:that.answerForm.optionCode,optionContent:that.answerForm.optionContent});
                    that.answerFormVisible = false
                  }
                }
                //编辑选项
                that.addForm.edit=function(index,row){
                  that.answerFormVisible=true;
                  //赋值
                  that.answerForm.optionCode=row.optionCode;
                  that.answerForm.optionContent=row.optionContent;
                  //获取已经添加的选项
                  that.answerCode=['A','B','C','D','E','F','G','H','I','J','K','L','M','N'];
                  if(that.addForm.data.answers.length>0)
                  {
                    that.addForm.data.answers.forEach((item) => {
                      if(item.optionCode!=row.optionCode){
                        let index = that.answerCode.indexOf(item.optionCode);
                        that.answerCode.splice(index,1);
                      }
                    });
                  };
                  //编辑提交
                  that.answerForm.submit=function(){
                    //如果row.id不为空，需要想服务端请求删除数据
                    if(row.id){
                      let eidtparams = {
                        id:row.id,
                        optionCode:that.answerForm.optionCode,
                        optionContent:that.answerForm.optionContent
                      }
                      that.loading = true;
                      API.editAnswer(eidtparams)
                        .then(
                          function (result) {
                            that.loading = false;
                            if (result && result.code == 200) {
                              let answerTemp = that.addForm.data.answers[index];
                              answerTemp.optionCode =that.answerForm.optionCode;
                              answerTemp.optionContent = that.answerForm.optionContent;
                              that.answerFormVisible = false
                            }
                          },
                          function (err) {
                            that.loading = false;
                            that.$message.error({
                              showClose: true,
                              message: err.toString(),
                              duration: 2000
                            });
                          }
                        )
                        .catch(function (error) {
                          that.loading = false;
                          console.log(error);
                          that.$message.error({
                            showClose: true,
                            message: "请求出现异常",
                            duration: 2000
                          });
                        });
                    }else{
                      let answerTemp = that.addForm.data.answers[index];
                      answerTemp.optionCode =that.answerForm.optionCode;
                      answerTemp.optionContent = that.answerForm.optionContent;
                      that.answerFormVisible = false
                    }
                  }
                }
                //删除选项
                that.addForm.delete=function(index,row){
                  //如果row.id不为空，需要想服务端请求删除数据
                  if(row.id){
                    that.loading = true;
                     API.delAnswer(row.id)
                        .then(
                          function (result) {
                            that.loading = false;
                            if (result && result.code == 200) {
                              that.addForm.data.answers.splice(index,1);
                            }
                          },
                          function (err) {
                            that.loading = false;
                            that.$message.error({
                              showClose: true,
                              message: err.toString(),
                              duration: 2000
                            });
                          }
                        )
                        .catch(function (error) {
                          that.loading = false;
                          console.log(error);
                          that.$message.error({
                            showClose: true,
                            message: "请求出现异常",
                            duration: 2000
                          });
                        });
                  }
                  else{
                    that.addForm.data.answers.splice(index,1);
                  }
                  
                } 
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      },
      //删除按钮
      delQuestion:function(index,row){
        let that = this;
        this.$confirm('您确定要删除此题目吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.loading = true;
          API.deleteById(row.id)
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 200) {
                  that.questionbanks.splice(index,1);
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 2000
                  });
                }else{
                  that.$message.error({
                    showClose: true,
                    message: "删除失败",
                    duration: 2000
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      //编辑提交
      editSubmit:function(){
        let that = this;
        let params=that.addForm.data;
        //刷选出要新加的选项
        let answers = params.answers;
        let temp=[];
        answers.forEach((a,b)=>{
          if(!a.id){
            temp.push(a);
          }
        });
        params.answers = temp;
        that.loading =true;
        API.edit(params)
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 200) {
                  that.detailEditDialogVisible=false;
                  let temp = that.questionbanks[that.editIndex];
                  temp.type=params.type;
                  temp.title = params.title;
                  temp.correct = params.correct;
                  console.log(that.questionbanks);
                  that.$message.success({
                    showClose: true,
                    message: "编辑成功",
                    duration: 2000
                  });
                }else{
                  that.$message.error({
                    showClose: true,
                    message: "编辑失败",
                    duration: 2000
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
      }
    },
    //页面load加载
     mounted() {
      this.handleSearch();
    }
}
</script>


// WEBPACK FOOTER //
// questionbank.vue?361d8b70